export const ALIAS_VERIFICATION_STATUS = {
  IDLE: "idle",
  VERIFIED: "verified",
  UNVERIFIED: "unverified",
};
